<template>
  <div>
    <section class="content">
      <h2>详情</h2>
      <ul v-if="details != ''">
        <li>
          <label>姓名：</label>
          <p>{{ details.user_name }}</p>
        </li>
        <li>
          <label>手机号码：</label>
          <p>{{ details.phone }}</p>
        </li>
        <li>
          <label>类型：</label>
          <p v-if="details.employee_type == 1">内部员工</p>
          <p v-else-if="details.employee_type == 2">三方员工</p>
          <p v-else>未知</p>
        </li>
        <li>
          <label>入职时间：</label>
          <p>
            {{
              details.entry_time != undefined && details.entry_time != ""
                ? details.entry_time.substring(0, 10)
                : ""
            }}
          </p>
        </li>
        <li
          v-if="details.company_info != '' && details.company_info != undefined"
        >
          <label>所在公司：</label>
          <p>{{ details.company_info[0].company_name }}</p>
        </li>
        <li v-if="details.role_info != ''">
          <label>岗位：</label>
          <span v-for="(element, k) in details.role_info" :key="k">
            <p v-show="k > 0">&nbsp;|&nbsp;</p>
            <p>{{ element.role_name }}</p>
          </span>
        </li>
        <li>
          <label>关联项目：</label>
          <span
            v-show="details.entry_info != ''"
            v-for="(element, j) in details.entry_info"
            :key="j"
          >
            <p v-show="j != 0 && j > 0">&nbsp;|&nbsp;</p>
            <p>{{ element.project_name }}</p>
          </span>
        </li>
        <li>
          <label>创建时间：</label>
          <p>{{ details.create_time }}</p>
        </li>
        <li>
          <label>修改时间：</label>
          <p>{{ details.update_time }}</p>
        </li>
        <li>
          <label>账号状态：</label>
          <p v-if="details.status == 1">禁用</p>
          <p v-else-if="details.status == 0">正常</p>
          <p v-else>未知</p>
        </li>
        <li>
          <label>在线状态：</label>
          <p v-if="details.is_login == 1">在线</p>
          <p v-else-if="details.is_login == 0">不在线</p>
          <p v-else>未知</p>
        </li>
        <li>
          <label>登录次数：</label>
          <p>{{ details.login_count }}</p>
        </li>
      </ul>
    </section>
  </div>
</template>
<script>
export default {
  data() {
    return {
      details: {}
    };
  },
  props: {
    detail: {}
  },
  watch: {
    detail() {
      this.details = this.detail;
      console.log(this.details);
    }
  },
  mounted() {
    if (this.details != undefined) {
      this.details = this.detail;
    }
  }
};
</script>
<style lang="less" scoped>
.content {
  padding: 30px 4%;
  // margin: 30px 2%;
  h2 {
    font-weight: normal;
    line-height: 24px;
    margin-bottom: 20px;
  }
  > ul {
    > li {
      margin-top: 10px;
      p,
      label,
      span {
        font-size: 14px;
        line-height: 20px;
        display: inline-block;
      }
    }
  }
}
</style>
